import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import { concat as _concat, keys as _keys, values as _values, camelCase as _camelCase, pick as _pick } from 'lodash';

import { whiteLabelPluginOptionFromEntity } from 'components/forms/autocomplete/WhiteLabelPlugin';

import EntityPropsUpdater from 'component/EntityPropsUpdater';

import CreacheckConditions from 'components/layout/whiteLabel/CreacheckConditions';
import CreacheckItemCalculation from 'components/layout/item/CreacheckItemCalculation';

import FormSwitchery from 'components/forms/FormSwitchery';
import FormAutocomplete from 'components/forms/FormAutocomplete';
import DatePicker from 'components/forms/DatePicker';

class ClientConditions extends EntityPropsUpdater {
  constructor(props) {
    super(props);
  }

  updateMainEntity = (name, value) => {
    const { entity, changeEntity } = this.props;
    changeEntity({ ...entity.updateValue(name, value, []) });
  };

  render() {
    const {
      intl: { messages },
      appIntl,
      entityLoaded,
      entity,
      disabled,
      inModal,
      user,
    } = this.props;

    return (
      <div className="clearfix">
        {entityLoaded && (
              <>
                <CreacheckItemCalculation
                  inModal={inModal}
                  entity={entity}
                  updateEntity={this.updateMainEntity}
                  disabled={disabled}
                />
              </>
            )}
      </div>
    );
  }
}
ClientConditions.defaultProps = {
  inModal: false,
};

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    user: state.login.user,
  };
};

export default injectIntl(connect(mapStateToProps)(ClientConditions));
